import { Season } from './Season';
import { User } from './User';
import { DeckType } from './DeckType';

export type Game = {
  id: string,
  season: Season,
  format: 'BO1' | 'BO3',
  host: GamePlayer
  guest: GamePlayer
  player_uuids: string[]
  winner?: 'host' | 'guest',
  duels?: Duel[],
  start_time: number,
  end_time?: number,
}

export type GamePlayer = User & { deck_type: DeckType, rate_diff?: number }

export type Duel = {
  game_number: number,
  is_win: boolean,
  is_first: boolean,
}

export function isWin(duels: Duel[]) {
  return duels.filter(it => it.is_win).length > duels.length/2
}

export function isHost(user: User, game: Game): boolean {
  return user.uuid === game.host.uuid
}

export function isWinner(user: User, game: Game): boolean {
  return isHost(user, game) ? game.winner === 'host' : game.winner === 'guest'
}

export function isLoser(user: User, game: Game): boolean {
  return isHost(user, game) ? game.winner === 'guest' : game.winner === 'host'
}

export function getUser(user: User, game: Game): GamePlayer {
  return isHost(user, game) ? game.host : game.guest
}

export function getOpponent(user: User, game: Game): GamePlayer {
  return isHost(user, game) ? game.guest : game.host
}